import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-4 overflow-hidden" data-id="element-61">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-62">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-sage rounded-full blur-3xl opacity-60" data-id="element-63"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-accent rounded-full blur-3xl opacity-20" data-id="element-64"></div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="inline-block bg-sage text-primary font-semibold px-4 py-1.5 rounded-full text-sm mb-6 border border-primary/20" data-id="element-67">
            Para la Madre Latina en USA
          </motion.div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight text-primary mb-6" data-id="element-68">
            Cero Inflamación 7D: <br data-id="element-69" />
            <span className="text-ink" data-id="element-70">El Protocolo de Rescate</span>
          </h1>

          <p className="text-lg md:text-xl text-ink/80 mb-8 max-w-2xl leading-relaxed" data-id="element-71">
            Desinflama tu vientre, recupera tu energía y vuelve a cerrar tus
            jeans favoritos en solo 7 días (sin dietas imposibles ni horas de
            gimnasio).
          </p>

          <div className="flex flex-col items-center lg:items-start w-full sm:w-auto" data-id="element-72">
            <CTAButton className="mb-4" data-id="element-73" />
            <div className="flex items-center gap-2 text-sm font-medium text-ink/70" data-id="element-74">
              <span className="flex h-2 w-2 rounded-full bg-cta" data-id="element-75"></span>
              Precio Especial:{' '}
              <span className="font-bold text-cta text-base" data-id="element-76">$6.39</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-77">
          {/* Decorative blob behind image */}
          <div className="absolute inset-0 bg-accent/20 rounded-[40px] transform rotate-3 scale-105 -z-10" data-id="element-78"></div>

          <img src="https://cdn.magicpatterns.com/uploads/f6nEyr9JRHGX8v4wYFs846/Cero_inflamacion_7D.png" alt="Cero Inflamación 7D Protocolo en Tablet" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white object-cover" data-id="element-79" />

          {/* Floating badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1,
          duration: 0.6
        }} className="absolute -bottom-6 -right-6 md:-right-10 bg-white p-4 rounded-xl shadow-xl border border-sage flex items-center gap-3" data-id="element-80">
            <div className="bg-sage text-primary p-2 rounded-full" data-id="element-81">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-82">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-83" />
              </svg>
            </div>
            <div data-id="element-84">
              <p className="text-xs text-ink/60 font-medium" data-id="element-85">Resultados en</p>
              <p className="text-lg font-bold text-primary" data-id="element-86">Solo 7 Días</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}